import classNames from "classnames";

import { ITEM_TYPES } from "@/components/CategoryTree/CategoryTree";
import { useFilterHandlers } from "@/components/filter/useFilterHandlers";

import styles from "./SubCategoryFilterItem.module.scss";

interface SubCategoryFilterItemProps {
  id: string;
  name: string;
  selected?: boolean;
  itemType?: ITEM_TYPES;
}

const SubCategoryFilterItem = ({
  id,
  name,
  selected,
  itemType = ITEM_TYPES.CATEGORY,
}: SubCategoryFilterItemProps) => {
  const { applyCategories, applyCollections } = useFilterHandlers();
  const onClick = () => {
    switch (itemType) {
      case ITEM_TYPES.CATEGORY: {
        applyCategories([id]);
        break;
      }
      case ITEM_TYPES.COLLECTION: {
        applyCollections([id]);
        break;
      }
    }
  };

  return (
    <li
      className={classNames(styles.link, {
        [styles.selected]: selected,
      })}
      onClick={onClick}
    >
      {name}
    </li>
  );
};

export default SubCategoryFilterItem;
